import { toast } from "react-toastify";
import { CustomToast } from "../../CustomToast";
import { getErrorMessage } from "../../../../utils/getErrorMessage";
import {
  useGetSectionConfigQuery,
  useSetSectionConfigMutation,
} from "../../../../api";
import { ReuseManageSectionsModal } from "../ReuseManageSectionModal";
import { SectionItemType } from "../../../../types/apiTypes";
import { ManageFields } from "../../../../types/enums";

const text = {
  [ManageFields.sdr_playbook_fields]: {
    title: "SDR Playbook Sections",
    description:
      "Select which sections will appear in SDR playbooks for this campaign’s contacts.",
    includeText: "Choose the sections to include in the Playbook",
  },
  [ManageFields.account_plan_fields]: {
    title: "Account Plan Sections",
    description:
      "Select which sections will appear in account plans for this campaign’s accounts.",
    includeText: "Choose the sections to include in the Account Plan",
  },
};

export const ConfigSectionModal = ({
  campaign_id,
  type,
  onClose,
  onBack,
}: {
  campaign_id: string;
  type: ManageFields;
  onClose?: () => void;
  onBack?: () => void;
}) => {
  const [setSectionConfig, { isLoading }] = useSetSectionConfigMutation();

  const { data: sections, isLoading: isSectionsLoading } =
    useGetSectionConfigQuery(
      {
        campaign_id,
      },
      { refetchOnMountOrArgChange: true },
    );

  const submitHandler = (selectedSections: Record<string, SectionItemType>) => {
    setSectionConfig({ campaign_id, [type]: selectedSections })
      .unwrap()
      .then(() => onClose && onClose())
      .catch((err) => {
        toast.error(
          <CustomToast
            type={"error"}
            text={
              getErrorMessage(err).globalError ||
              "Something went wrong. Please try again"
            }
            title={"Something went wrong"}
          />,
        );
      });
  };

  const { title, includeText, description } = text[type];

  return (
    <ReuseManageSectionsModal
      sections={sections && sections[type]}
      title={title}
      includeText={includeText}
      description={description}
      isLoading={isLoading || isSectionsLoading}
      onSubmit={submitHandler}
      onClose={onClose}
      onBack={onBack}
    />
  );
};
